import { FC, lazy, Suspense, useEffect } from "react";
import "./App.css";
import Cursor from "./components/cursor";
import { LoadingProvider, useLoading } from "./context/LoadingContext";
import Preloader from "./components/preloading";

// -------------------------------------------------------------------------------

const Header = lazy(() => import("./sections/header"));
const HeroSection = lazy(() => import("./sections/hero"));
const WhoImSection = lazy(() => import("./sections/whoIm"));
const Experience = lazy(() => import("./sections/experience"));
const MyWorks = lazy(() => import("./sections/myWorks"));
const ReachMe = lazy(() => import("./sections/contact"));
const MyPhilosophy = lazy(() => import("./sections/myPhilosophy"));
const Footer = lazy(() => import("./sections/footer"));
const Volunteering = lazy(() => import("./sections/volunteering"));
const Certificates = lazy(() => import("./sections/certificates"));

// -------------------------------------------------------------------------------

const AppContent: FC = () => {
  const { loading, setLoading } = useLoading();
  const supportsMouse = matchMedia("(pointer:fine)").matches;

  useEffect(() => {
    const waitForResources = async () => {
      const fontReady = document.fonts?.ready ?? Promise.resolve();
      const loadReady = new Promise<void>((resolve) => {
        if (document.readyState === "complete") {
          resolve();
          return;
        }
        const handleLoad = () => resolve();
        window.addEventListener("load", handleLoad, { once: true });
      });
      try {
        await Promise.all([fontReady, loadReady]);
      } finally {
        setLoading(false);
      }
    };

    waitForResources();
  }, [setLoading]);

  return (
    <>
      {supportsMouse && <Cursor />}
      {loading ? (
        <Preloader />
      ) : (
        <Suspense fallback={<Preloader />}>
          <>
            <Header />
            <main>
              <HeroSection />
              <WhoImSection />
              <Experience />
              <MyWorks />
              <Certificates />
              <Volunteering />
              <MyPhilosophy />
              <ReachMe />
            </main>
            <Footer />
          </>
        </Suspense>
      )}
    </>
  );
};

const App = () => {
  return (
    <LoadingProvider>
      <AppContent />
    </LoadingProvider>
  );
};

export default App;
